import {
    BoxedRow,
    IconMobileDeviceRegular,
    Inline,
    NavigationBar,
    Row,
    RowList,
    Spinner,
    Tag,
    Text1,
    Text2,
    Text6,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getAllConsDetail, getAllConsumption } from '../../../../services/ConsumptionService';
import {
    formatMobileNumber,
    conversionToGB,
    conversionKBtoMbOrGB,
} from '../../../../utils/dataTransformation/unitsConversion';
import './index.scss';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
interface IDataSharing {
    productPsId: string;
    number: string;
    isMain: boolean;
    data?: { unit: string; current: number; max: number; extra: number };
    dataShared: { unit: string; current: number; max: number; extra: number };
}

interface IMobileConsumption {
    productPsId: string;
    number: string;
    unit: string;
    current: number;
    max: number;
    extra: number;
}

const SharedData: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const size = useWindowSize();
    const { trackingScreenView } = new TrackingEvents();
    const [loading, setLoading] = useState<boolean>(true);
    const storage = localStorage.getItem('storage');
    let storageJson: any;
    if (storage) {
        storageJson = JSON.parse(storage);
    }
    const { dataSharing, sharedData } = storageJson;
    const [lines, setLines] = useState<IMobileConsumption[] | null>(null);

    const getDataMobile = (mobile: IMobileConsumption) => {
        return {
            rate: `${t('rateSharedDataDetails')} ${conversionToGB(mobile?.unit, mobile?.max, 0)}`,
            current: conversionKBtoMbOrGB(mobile?.current),
        };
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const isMain: IDataSharing = sharedData?.filter((item: IDataSharing) => item.isMain)[0];
        const restAdditionalsLines = sharedData
            ?.map((item: IDataSharing) => {
                const { isMain, productPsId } = item;
                if (!isMain) {
                    return getAllConsDetail({
                        productPsId,
                        consumptionType: 'DATA',
                    });
                }
            })
            .filter((item: any) => typeof item !== 'undefined');
        const productsIds: string[] = sharedData.map((item: IDataSharing) => item.productPsId);
        getAllConsumption(productsIds, size.width >= 1024 ? 'sharedData' : '')
            .then(async (consumption: AxiosResponse) => {
                const consumptions = await Promise.allSettled([
                    getAllConsDetail({
                        productPsId: isMain.productPsId,
                        consumptionType: 'DATA',
                    }),
                    ...restAdditionalsLines,
                ]);
                const acumulatorConsume = (items: []) => {
                    const current = (items as []).reduce((prev: any, current: any) => prev + current.usage, 0);
                    return {
                        current,
                    };
                };
                let _lines: IMobileConsumption[] = [];
                consumptions.map((item: any, index: number) => {
                    const { value } = item;
                    const { data } = value;
                    if (data.productPsId === isMain.productPsId) {
                        const { number, productPsId, dataShared } = isMain;
                        const max: number = consumption.data.consumptions.filter(
                            (item: any) => item.productPsId === data.productPsId,
                        )[0].data.max;
                        let mainMobile = {
                            ...dataShared,
                            max,
                            number,
                            productPsId,
                            isMain: true,
                            ...acumulatorConsume(data.details),
                        };
                        _lines.push(mainMobile);
                    } else {
                        const _mobiles: IDataSharing = consumption.data.consumptions.filter(
                            (item: IDataSharing) => item.productPsId === data.productPsId,
                        )[0];
                        const number: string = sharedData.filter(
                            (item: any) => item.productPsId === data.productPsId,
                        )[0].number;
                        const { productPsId } = _mobiles;
                        let additional = {
                            ..._mobiles.data!,
                            number,
                            productPsId,
                            ...acumulatorConsume(data.details),
                        };
                        _lines.push(additional);
                    }
                    if (index === consumptions.length - 1) setLines(_lines);
                    setLoading(false);
                });
            })
            .catch(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        if (size.width >= 1024) {
            return (
                <div
                    className='sharedData-page__loading'
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        color: skinVars.colors.textSecondary,
                        padding: '16px',
                    }}
                >
                    <Inline space={8} alignItems='center'>
                        <Spinner size={24} color={skinVars.colors.navigationBarBackground}></Spinner>
                        {t('loading')}
                    </Inline>
                </div>
            );
        } else {
            return (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
                </div>
            );
        }
    }

    return (
        <div className='sharedData-page'>
            {!(isWebviewAndroid || isWebviewIOS) && (
                <>
                    <div className='MobileConsumption__mobile-navigationBar'>
                        <NavigationBar
                            onBack={() => {
                                navigate(-1);
                            }}
                            title={t('sharedDataDetails')}
                        />
                    </div>
                </>
            )}
            <div className='sharedData-page__card' style={{ background: skinVars.colors.background, height: '48px' }}>
                <BoxedRow
                    headline={
                        <div className='sharedData-page__card-headline'>
                            <Text1 medium color={skinVars.colors.textSecondary}>
                                {t('consumptionDetailsHeader')}
                            </Text1>
                            <div className='sharedData-page__card-headline-consumption'>
                                <div className='sharedData-page__card-headline-consumption-gigs'>
                                    <Text6>{conversionToGB(dataSharing?.unit, dataSharing?.current, 2)}</Text6>
                                </div>
                                <Text2 regular>
                                    {t('of')} {conversionToGB(dataSharing?.unit, dataSharing?.max, 0)}
                                </Text2>
                            </div>
                        </div>
                    }
                    title={''}
                />
            </div>

            <div className='sharedData-page__consumo'>
                <Text1 medium color={skinVars.colors.textSecondary}>
                    {t('titleSharedDataDetails')}
                </Text1>
            </div>
            <div className='sharedData-page__content'>
                <RowList>
                    {lines &&
                        lines!.map((item: any, index: number) => {
                            const max = getDataMobile(item).rate;
                            const current = getDataMobile(item).current;
                            return (
                                <div key={index}>
                                    <Row
                                        asset={<IconMobileDeviceRegular />}
                                        headline={
                                            <Tag type='active'>
                                                {item.isMain ? t('principalLine') : t('additionalLine')}
                                            </Tag>
                                        }
                                        title={formatMobileNumber(item.number)}
                                        description={max}
                                        right={<Text6>{current}</Text6>}
                                    ></Row>
                                </div>
                            );
                        })}
                </RowList>
            </div>
        </div>
    );
};

export default SharedData;
